import React from 'react';

export default function ReorderIcon(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 12.3 10.2"
      style={{ enableBackground: 'new 0 0 12.3 10.2' }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="XMLID_1_">
        <path
          id="XMLID_4_"
          d="M7.9,4.6L7.7,4.9c0,0.2,0.2,0.3,0.4,0.2l0.1-0.1c1.1-0.6,2.8-1.6,3.9-2.2l0.1-0.1
        		c0.2-0.1,0.2-0.4,0-0.5l-0.1-0.1C11,1.7,9.3,0.7,8.3,0.1L8.2,0C8-0.1,7.8,0.1,7.8,0.3L8,0.8C8.2,1.1,8.3,1.6,8.4,2H0v1h8.4
        		C8.4,3.6,8.2,4.2,7.9,4.6z"
        />
        <path
          id="XMLID_7_"
          d="M4.4,5.6l0.2-0.3C4.6,5,4.4,4.9,4.2,5L4.1,5.1C3,5.7,1.3,6.7,0.2,7.3L0.1,7.3
        		C0,7.4,0,7.7,0.1,7.8l0.1,0.1C1.3,8.5,3,9.5,4.1,10.1l0.1,0.1c0.2,0.1,0.4,0,0.4-0.2L4.3,9.4C4.1,9.1,4,8.6,3.9,8.2h8.4v-1H3.9
        		C4,6.6,4.1,6,4.4,5.6z"
        />
      </g>
    </svg>
  );
}
